// Autogenerated file
export const internalEntityTypesEnum = {
    Bid: "Bid",
    DistributionBid: "DistributionBid",
    Car: "Car",
    Trailer: "Trailer",
    Driver: "Driver",
    Counterparty: "Counterparty",
};
export const internalEntityTypes = [
    { label: "Заявка", value: "Bid" },
    { label: "Заказ", value: "DistributionBid" },
    { label: "Машина", value: "Car" },
    { label: "Прицеп", value: "Trailer" },
    { label: "Водитель", value: "Driver" },
    { label: "Контрагент", value: "Counterparty" },
];
